export default {
    name: 'StreamDonationOverviewPreviousDonation',
    props: {
        variation: {
            type: String,
            default: 'dark'
        },
        amount: {
            type: Number,
            default: null
        },
        donorName: {
            type: String,
            default: null
        },
        donationStyle: {
            type: String,
            default: 'normal'
        },
        index: {
            type: Number,
            default: 0
        }
    },
    setup() {}
}
